import { SalesOffersService } from "../../../api/salesOffers"
import { useCreateWarehouseDocumentDraft } from "../shared/useCreateWarehouseDocumentDraft"

type CreateOSOptions = {
  preferredWarehouseId?: string
  replace?: boolean
  prefilledItems?: any[]
}

export function useCreateOS() {
  const { createDocument, isCreating, isResolvingWarehouses, canCreate } =
    useCreateWarehouseDocumentDraft<
      { warehouse_id: string },
      { id: string },
      CreateOSOptions
    >({
      mutationKey: ["wms", "sales-offers"] as const,
      documentCode: "OS",
      blockedWarehouseDescription:
        "Magazyn z kontekstu jest obecnie zablokowany przez aktywną inwentaryzację.",
      missingWarehouseDescription:
        "Brak aktywnego magazynu dostępnego do utworzenia dokumentu OS.",
      createDraftRequest: async (payload, options?: CreateOSOptions) => {
        const draft = await SalesOffersService.initSalesOfferDraft(payload)
        if (options?.prefilledItems && options.prefilledItems.length > 0) {
          await SalesOffersService.updateSalesOfferByID(draft.id, {
            items: options.prefilledItems.map(
              (item) =>
                ({
                  product_id: item.product_id,
                  qty: item.qty,
                  price: item.price,
                  vat_rate: item.vat_rate,
                  location_code: item.location_code,
                  warehouse_lot_id: item.warehouse_lot_id,
                  partia: item.partia,
                  lot_no: item.lot_no,
                  production_date: item.production_date,
                  expiration_date: item.expiration_date,
                }) as any,
            ),
          })
        }
        return draft
      },
      buildPayload: (warehouseId) => ({
        warehouse_id: warehouseId,
      }),
      getSuccessNavigation: (draft, options) => ({
        to: "/WMS/documents/sales-offers/$salesOffer",
        params: { salesOffer: draft.id },
        search: { tab: "general", edit: 1 } as any,
        replace: Boolean(options?.replace),
      }),
    })

  return {
    createOS: (options?: CreateOSOptions) => createDocument(options),
    isCreating,
    isResolvingWarehouses,
    canCreate,
  }
}
